import { PlayerPosition, PlayerStatus } from "src/app/enums/Index";
import { Model } from "./Model";
import { Sponsor, Team } from "./Index";

export interface ServiceContractFile{
	fileName: string;
	dateUploaded: Date;
	fileUrl: string;
	
}

export class ServiceContractFile implements ServiceContractFile {

	constructor(data?: Partial<ServiceContractFile>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}